import React, {
    useState,
    useEffect
} from "react";

import {
    FontAwesomeIcon
} from "@fortawesome/react-fontawesome";


export default function UtilisationSpaceTypeHeader({
    id,
    title,
    icon,
    color,
    clickFunction
})
{

    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [ready, setReady] =
        useState(false);

    const [hovered, setHovered] =
        useState(false);


    //--------------------------------------------------------
    // Entrance animation
    //--------------------------------------------------------

    useEffect(
        function()
        {

            const timer =
                setTimeout(
                    function()
                    {
                        setReady(
                            true
                        );
                    },
                    id * 120
                );


            return function()
            {
                clearTimeout(
                    timer
                );
            };

        },
        [id]
    );


    //--------------------------------------------------------
    // Click
    //--------------------------------------------------------

    const handleClick =
        function()
        {

            if(clickFunction)
            {
                clickFunction();
            }

        };


    //========================================================
    // Styles
    //========================================================


    //--------------------------------------------------------
    // Main category tile
    //--------------------------------------------------------

    const headerComponent =
    {
        position:
            "relative",

        display:
            "flex",

        margin:
            "10px",

        height:
            "80px",

        width:
            "calc(20% - 25px)",

        alignItems:
            "center",

        overflow:
            "hidden",

        boxSizing:
            "border-box",

        /*
         * Keep the existing category colour,
         * but remove the old gradient.
         */

        background:
            color,

        /*
         * Structural tile = square.
         */

        borderRadius:
            "0px",

        border:
            "1px solid rgba(255,255,255,0.16)",

        boxShadow:
            hovered
                ?
                "0 9px 22px rgba(7,28,49,0.22)"
                :
                "0 6px 16px rgba(7,28,49,0.14)",

        cursor:
            "pointer",

        /*
         * Entrance animation + hover movement.
         */

        opacity:
            ready
                ? 1
                : 0,

        transform:
            ready
                ?
                (
                    hovered
                        ? "translateY(-3px)"
                        : "translateY(0px)"
                )
                :
                "translateY(20px)",

        transition:
            "opacity 0.5s ease, " +
            "transform 0.22s ease, " +
            "box-shadow 0.22s ease"
    };


    //--------------------------------------------------------
    // Very subtle depth overlay
    //--------------------------------------------------------

    const overlay =
    {
        position:
            "absolute",

        left:
            "0px",

        top:
            "0px",

        width:
            "100%",

        height:
            "100%",

        background:
            "linear-gradient(" +
                "90deg," +
                "rgba(7,28,49,0.10) 0%," +
                "rgba(7,28,49,0.02) 55%," +
                "rgba(255,255,255,0.04) 100%" +
            ")",

        pointerEvents:
            "none",

        zIndex:
            1
    };


    //--------------------------------------------------------
    // Watermark icon
    //--------------------------------------------------------

    const headerIcon =
    {
        position:
            "absolute",

        right:
            "-8px",

        bottom:
            "-18px",

        width:
            "86px",

        height:
            "86px",

        color:
            "rgba(255,255,255,0.15)",

        pointerEvents:
            "none",

        zIndex:
            2,

        transform:
            hovered
                ? "scale(1.06)"
                : "scale(1)",

        transition:
            "transform 0.3s ease"
    };


    //--------------------------------------------------------
    // Title
    //--------------------------------------------------------

    const headerTitle =
    {
        position:
            "relative",

        zIndex:
            3,

        display:
            "flex",

        alignItems:
            "center",

        paddingLeft:
            "22px",

        paddingRight:
            "70px",

        color:
            "#ffffff",

        fontSize:
            "16px",

        fontWeight:
            600,

        lineHeight:
            "20px",

        textShadow:
            "0 1px 2px rgba(0,0,0,0.12)"
    };


    //========================================================
    // Render
    //========================================================

    return (

        <div
            style={
                headerComponent
            }

            onClick={
                handleClick
            }

            onMouseEnter={
                function()
                {
                    setHovered(
                        true
                    );
                }
            }

            onMouseLeave={
                function()
                {
                    setHovered(
                        false
                    );
                }
            }
        >

            {/* -----------------------------------------------
                Subtle depth
            ------------------------------------------------ */}

            <div
                style={
                    overlay
                }
            />


            {/* -----------------------------------------------
                Title
            ------------------------------------------------ */}

            <div
                style={
                    headerTitle
                }
            >

                {title}

            </div>


            {/* -----------------------------------------------
                Watermark
            ------------------------------------------------ */}

            <FontAwesomeIcon
                icon={
                    icon
                }

                style={
                    headerIcon
                }
            />

        </div>

    );

}